import { render, staticRenderFns } from "./EcOrder.vue?vue&type=template&id=2880f824&scoped=true&"
import script from "./EcOrder.vue?vue&type=script&lang=js&"
export * from "./EcOrder.vue?vue&type=script&lang=js&"
import style0 from "./EcOrder.vue?vue&type=style&index=0&id=2880f824&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2880f824",
  null
  
)

export default component.exports